<div class="sim-modal" [ngClass]="modalWidth" [ngClass]="{ 'dark-mode-modal': darkMode }">
  <button id="modal-close" (click)="close.emit()" class="close cursor-pointer" *ngIf="showCloseButton">
    <sim-icon [color]="darkMode ? '#E9ECEF' : '#000'" icon="close2" />
  </button>
  <ng-content />
</div>
